import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    historialEnvios: [],
    historialEnviosExcel:[],
    ultimaRef:0,
  },
  mutations: {

    getEnvios(state, datos) {
      state.historialEnvios = datos;
    },

    destroyHistorialEnvios(state) {
      state.historialEnvios = [];
    },
    getUltimaRef(state,datos) {
      state.ultimaRef = datos;
    },
    getEnviosParaExcel(state,datos) {
      state.historialEnviosExcel = datos;
    },


  },
  actions: {

    async destroyHistorialEnvios({ commit }) {
      commit('destroyHistorialEnvios');
    },

    async insertEnvios({ commit }, env) {
      try {
        const res = await api.insertEnvios(env);
        if (res.data.INFO.cod === '200') {
          commit('abonosEnvios/destroyStoreAbonosEnvios', '', { root: true });

          return [true, res.data];
        } return [false, res.data.INFO];
      } catch (error) {
        console.log('error insercion server');
        return [false, 'errorinsertenvios'];
      }
    },

    async deleteEnvios({ commit }, env) {
      try {
        const res = await api.deleteEnvios(env);
        if (res.data.INFO.cod === '200') {

          return [true, res.data];
        } return [false, res.data.INFO];
      } catch (error) {
        console.log('error insercion server');
        return [false, 'errorinsertenvios'];
      }
    },

    async getUltimaRef({
      commit,
    },) {
      try {
        const res = await api.getUltimaRef();
        // console.log(object);
        if (res.data.INFO.cod === '200') {
          commit('getUltimaRef', res.data.DATOS[0].ID);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async getEnvios({
      commit,
    }, env) {
      try {
        const res = await api.getEnvios(env);
        // console.log(object);
        if (res.data.INFO.cod === '200') {
          commit('getEnvios', res.data);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async getEnviosParaExcel({
      commit,
    }, env) {
      try {
        const res = await api.getEnviosParaExcel(env);
        // console.log(object);
        if (res.data.INFO.cod === '200') {
          commit('getEnviosParaExcel', res.data);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },



  },
};
